"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDirectDebitDate = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var with_customer_and_account_ids_1 = require("../../../../shared/core/utils/with-customer-and-account-ids");
var analytics_subjects_1 = require("../../analytics-subjects");
var data_1 = require("../../data");
var section_ids_1 = require("../../section-ids");
var ui_1 = require("./ui");
var Error = function () {
    var _a;
    var ErrorSection = (0, core_1.useComponents)().ErrorSection;
    return (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.AMEND_DD_DATE_ERROR, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement("section", null,
            react_1.default.createElement(ErrorSection, { id: section_ids_1.CHANGE_DIRECT_DEBIT_DATE_ERROR }))));
};
exports.ChangeDirectDebitDate = (0, with_customer_and_account_ids_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var accountId = _a.accountId, customerId = _a.customerId;
    var _c = (0, data_1.usePaymentDetails)({ accountId: accountId }), loading = _c.loading, error = _c.error, data = _c.data;
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.AMEND_DD_DATE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) }, loading ? (react_1.default.createElement(ui_1.Loading, null)) : error && error.errorCode === 'GENERIC' ? (react_1.default.createElement(Error, null)) : (react_1.default.createElement(ui_1.ChangeDirectDebitDateUI, { accountId: accountId, customerId: customerId, paymentDetails: data, apiErrorCode: error === null || error === void 0 ? void 0 : error.errorCode }))));
}, ui_1.Loading);
